import PropTypes from 'prop-types';

import standardMessage from 'fera-prop-types/storylet/standardMessage';

export { default as event } from 'fera-prop-types/storylet/event';
export { default as endStorylet } from 'fera-prop-types/storylet/endStorylet';
export { default as qualityRequirement } from 'fera-prop-types/storylet/qualityRequirement';
export { default as storylet } from 'fera-prop-types/storylet/storylet';

const {
  arrayOf,
  shape,
  string,
} = PropTypes;

export const defaultMessage = shape({
  image: string, // can be undefined
  message: string,
  tooltip: string,
  type: string.isRequired,
});


export const message = shape({
});

export const messages = shape({
  defaultMessages: arrayOf(defaultMessage).isRequired,
  difficultyMessages: arrayOf(message).isRequired,
  headlineMessages: arrayOf(message).isRequired,
  hiddenMessages: arrayOf(message).isRequired,
  standardMessages: arrayOf(standardMessage).isRequired,
});